/**
 * SHorten string by words to a given length, with suffix - default ellipsis
 * @param  {string} str - source string
 * @param  {number} length - expected length of the resulting string
 * @param  {string='…'} suffix - defaults to '…'
 * @returns string
 */
export function shortenString(str: string, length: number, suffix: string = '…'): string {
  if (str.length <= length) return str;
  const lastSpace = str.slice(0, length - suffix.length + 1).lastIndexOf(' ');
  return str.slice(0, lastSpace > 0 ? lastSpace : length - suffix.length) + suffix;
}
